import configs from "@/i18n/configs"
export default {
    'this-double-visit-report': 'تقرير الزيارة المزدوجة',
    'add-new-report': 'إضافة تقرير جديد',
    'view-report': 'عرض تقرير',
    'delete-report': 'حذف تقرير',
    'pre-call-analysis': `${configs.preCallAnalysis.ar}`,
    call: `${configs.call.ar}`
}